import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';

export default function ActionMenu({ row }) {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton size='small' onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreVertIcon fontSize='small' />
      </IconButton>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(`/maintenance/product-sampling-details?plan_id=${row.plan_id}&type=pm`);
          }}
        >
          <ListItemIcon>
            <VisibilityIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText>View Details</ListItemText>
        </MenuItem>

        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate(`/maintenance/product-sampling-details/allocation?plan_id=${row.plan_id}`);
          }}
        >
          <ListItemIcon>
            <Inventory2OutlinedIcon fontSize='small' />
          </ListItemIcon>
          <ListItemText>View Allocation</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}

ActionMenu.propTypes = {
  row: PropTypes.shape({ plan_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
    .isRequired,
};
